import DescriptionIcon from '@mui/icons-material/Description'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'

export const routeFrontOfficeContracts = [
  {
    route: 'Contrat',
    text: 'Contrat',
    t: 'routes.frontoffice.all.contracts',
    icon: DescriptionIcon,
    href: '/frontoffice/group/contracts',
    menuHeader: true,
    // Menu v2 : rattache a la section commune « Ma pharmacie » (dedoublonne cross-entites).
    menuGroup: MENU_GROUPS.PHARMACY,
    position: 30,
    // Menu v2 : remonte dans « Actions a faire » quand des contrats restent a signer.
    actionable: true,
    fnBadge: ({ dataMyProfile }) =>
      !!dataMyProfile?.counterTaskEntityForMenu
        ? JSON.parse(dataMyProfile?.counterTaskEntityForMenu)?.contractsToSign
        : 0,
  },
]
